import { GridColDef } from '@mui/x-data-grid-premium'

const manufacturer: GridColDef = {
	field: 'provider',
	hideable: false,
	headerName: 'Manufacturer',
	width: 200,
	sortable: false,
	valueGetter: ( _value, row ) => row.manufacturer?.name ?? '',
}

export default manufacturer